<script setup>
import {computed, onMounted, ref} from 'vue'
import {dateFormat} from "@/utils/DateHelper.js";

const selectedWeek = ref(0)

const weeks = [
  { start: new Date('2025-07-14'), end: new Date('2025-07-20') },
  { start: new Date('2025-07-21'), end: new Date('2025-07-27') },
  { start: new Date('2025-07-28'), end: new Date('2025-08-03') },
  { start: new Date('2025-08-04'), end: new Date('2025-08-10') },
  { start: new Date('2025-08-11'), end: new Date('2025-08-17') },
];

const setSelectedWeek = () => {
  const today = new Date();
  // 현재 날짜에 해당하는 주차를 찾기
  // 예를 들어, 현재 날짜가 7월 15일이면 1번째 주차로 설정, 21일이면 2번째 주차로 설정
  const currentWeek = weeks.findIndex(
    (week) => today >= week.start && today <= week.end
  );

  selectedWeek.value = currentWeek !== -1 ? currentWeek : 1; // 기본값 1
}

const getRange = (range) => {

  return `${dateFormat(range.start, 'mm-dd')} - ${dateFormat(range.end, 'mm-dd')}`;
}

const selectedWeekPick = computed(() => {
  return weekPicks.value[selectedWeek.value] || weekPicks.value[0];
});
const weekPicks = ref([
  {
    week: 1,
    title: '30% 향수 워터 베이스 2종',
    image: 'https://image.candleworks.com/media/statics/weekpic1.jpg',
    url: 'https://chromaworks.co.kr/shop/category/148',
    discount: '30%',
    trendId: 26,
  },
  {
    week: 2,
    title: '5% 아크릴 조향대 & 유리 용기 세트(50ml)',
    image: 'https://image.candleworks.com/media/statics/weekpick2.jpg',
    url: 'https://chromaworks.co.kr/shop/product/3820',
    discount: '5%',
    trendId: 27,
  },
  {
    week: 3,
    title: '10% 투명 젤 왁스 3종',
    image: 'https://image.candleworks.com/media/statics/weekpick3.jpg',
    url: 'https://chromaworks.co.kr/shop/category/160',
    discount: '10%',
    trendId: 28,
  },
  {
    week: 4,
    title: '20% 디퓨저 글래스 3종',
    image: 'https://image.candleworks.com/media/statics/weekpick4.jpg',
    url: 'https://chromaworks.co.kr/shop/category/211',
    discount: '20%',
    trendId: 29,
  },
  {
    week: 4,
    title: '20% 시트로넬라 천연',
    image: 'https://image.candleworks.com/media/statics/weekpick5.jpg',
    url: 'https://chromaworks.co.kr/shop/product/1119',
    discount: '20%',
    trendId: 30,
  },
]);

const goTo = (url, target) => {
  window.open(url, target || '_blank');
}
const trendId = ref(26)


onMounted(() => {
  // 초기 선택 주차 설정
  setSelectedWeek();
})
</script>

<template>
  <div class="flex flex-col lg:gap-8 gap-4 lg:py-20 py-8 bg-stone-100">
    <h2 class="lg:text-5xl text-2xl text-blue-400 font-bold text-center">
      CW Week Picks
    </h2>
    <h3 class="lg:text-4xl text-xl text-center">
      {{ $t("CW가 선별한 위클리 대표 상품") }}
    </h3>

    <div
      class="mx-auto flex flex-col lg:gap-6 gap-3 items-center justify-center"
    >
      <!-- 상단 주간 선택 -->
      <div class="flex justify-between text-sm text-gray-400 mb-6 px-2 bg-gray-100 rounded-xl p-4 ">
        <div
          v-for="(label, index) in weeks"
          :key="index"
          class="text-center cursor-pointer border-r last:border-none px-2 md:px-4"
          :class="{ 'text-black font-bold': selectedWeek === index }"
          @click="()=>{selectedWeek = index}"
        >
          <p class="lg:text-lg text-sm font-semibold mb-1">
            Week{{ index + 1 }}
          </p>
          <p class="lg:text-base text-xs">
            {{ getRange(label) }}
          </p>
        </div>
      </div>
      <!-- 상품 카드 -->
      <div
        class="relative lg:max-w-[500px] min-w-[300px]"
      >
        <span
          class="rounded bg-blue-400 text-white absolute top-5 left-5 px-3 py-2 font-bold flex items-center justify-center"
        >
          {{ selectedWeekPick.discount }}
        </span>
        <img
          :src="selectedWeekPick.image"
          class="w-full h-auto rounded mb-4"
          :alt="selectedWeekPick.title"
        >
        <div class="absolute bottom-10 left-1/2 transform -translate-x-1/2 w-[80%]">
          <h4 class="text-xl font-semibold mb-2 w-full text-left text-white">
            {{ selectedWeekPick.title }}
          </h4>
          <button
            class="rounded bg-white py-4 px-8 w-full text-lg text-blue-400 font-bold hover:bg-blue-400 hover:text-white transition-colors duration-300"
            @click="goTo(selectedWeekPick.url, '_blank')"
          >
            {{ $t('상품 보러가기') }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-col lg:gap-8 gap-4 lg:py-20 py-8">
    <h2 class="lg:text-5xl text-2xl text-blue-400 font-bold text-center">
      Weekly Line-up
    </h2>
    <h3 class="lg:text-14xl text-xl text-center">
      {{ $t("한 주 동안 진행되는 세일 상품 ") }}
    </h3>
    <trend-render
      v-if="selectedWeekPick?.trendId"
      :trend-id="selectedWeekPick?.trendId"
      @change="(v)=>{selectedWeekPick.trendId = v}"
    />
  </div>
</template>

<style scoped>

</style>
